// Use for Generic Log Query Key Manager with Type
export const genericLogQueryType = {
    none: 'none',
    clientLog: 'clientLog',
    userLog: 'userLog',
    watchConfigLog: 'watchConfigLog',
    hcpRoleLog: 'hcpRoleLog',
    watchNotificationLog: 'watchNotificationLog',
    biometricsLog: 'biometricsLog',
    dischargeLog: 'dischargeLog',
    healthRecordLog: 'healthRecordLog',
    parameterLog: 'parameterLog',
    importLog: 'importLog',
    exportLog: 'exportLog',
    onWristLog: 'onWristLog',
    batteryChargeLog: 'batteryChargeLog',
    batteryLog: 'batteryLog',
    importAndExport: 'importAndExport',
}
